<script>
export default {
  name: "restaurantsVue",
  data() {
    return {
      geojsonFeature: {
        type: "FeatureCollection",
        name: "restaurants",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
        },
        features: [
          {
            type: "Feature",
            properties: {
              name: "Burgerhouse 3 Biergarten",
              address: "Schleißheimer Str. 234",
              toilets: "yes",
              website: "theburgerhouse.com/restaurant/biergarten/",
            },
            geometry: {
              type: "Point",
              coordinates: [11.565000339345714, 48.170270070591066, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Bei Ling Chinese Restaurant",
              address: "Karl-Theodor-Straße 97",
              toilets: "no",
              website: "-",
            },
            geometry: {
              type: "Point",
              coordinates: [11.570529051304522, 48.167322549016241, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Rabiang Thai Restaurant",
              address: "Georgenschwaigstraße 25",
              toilets: "yes",
              website: "www.rabiangthai.de",
            },
            geometry: {
              type: "Point",
              coordinates: [11.571347609666145, 48.18088991184684, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Hans im Glück",
              address: "Leopoldstraße 250 b",
              toilets: "yes",
              website:
                "hansimglueck-burgergrill.de/burger-restaurant/muenchen-leo250",
            },
            geometry: {
              type: "Point",
              coordinates: [11.585277302381703, 48.182222720634016, 0.0],
            },
          },
          {
            type: "Feature",
            properties: {
              name: "Marta Trattoria & Bar",
              address: "Leopoldstraße 156",
              toilets: "no",
              website: "marta.restaurant/",
            },
            geometry: {
              type: "Point",
              coordinates: [11.587193036081874, 48.170252189738683, 0.0],
            },
          },
        ],
      },
    };
  },
};
</script>
